import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { TableEventListMapper } from 'src/app/mapper/table/table-events.mapper';
import { EventsRepo } from 'src/app/repositories/event-repo';
import { AlertService } from 'src/app/services';
import { AlertParameters, AlertType } from 'src/app/shared/models/models-index';
import { EventLogEntryList, EventsLogFieldGroupType, FilterFieldGroupForEventLog } from 'src/swagger-gen/web-secured/models';
import { TableColumn } from '../../tinea-table/models/tableColumn';

@Component({
    selector: 'app-event-group',
    templateUrl: './event-group.component.html',
    styleUrls: ['./event-group.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EventGroupComponent implements OnInit {

  @Input() group: FilterFieldGroupForEventLog;

  @Input() tableColumns: TableColumn[] = [];

  @Input() data: any;

  eventsGroupSubscr: Subscription;

  limit = 100;
  offset = 0;

  isDown = true;

  cssClassForCollapse = 'down';

  eventsLogFieldGroupType = EventsLogFieldGroupType;

  /**
   * Current application language
   */
  language: 'fr' | 'en' = 'fr';

  /**
   * Date format to display depending of language
   */
  dateFormat: string;

  /**
   * List of grouped events
   */
  eventsList: EventLogEntryList;

  constructor(
    private eventsService: EventsRepo,
    private alertService: AlertService,
    private tableEventListMapper: TableEventListMapper
  ) { }

  ngOnInit() {
    this.setDateFormat();
  }

  /**
   * Set the date format depending on the language
   */
  setDateFormat() {
    if (this.language === 'fr') {
      this.dateFormat = 'dd/MM/yyyy';
    } else {
      this.dateFormat = 'MM/dd/yyyy';
    }
  }

  onClickGroup($event: any) {
    const element: Element = $event.target;
    const isDown = element.classList.contains(this.cssClassForCollapse);
    if (!isDown) {
      element.classList.add(this.cssClassForCollapse);
      this.getEventsLogListGroupByField(false);
      this.isDown = false;
    } else {
      element.classList.remove(this.cssClassForCollapse);
      this.eventsList = null;
      this.offset = 0;
      this.isDown = true;
    }
  }

  getEventsLogListGroupByField(pushList: boolean) {
    let params: any[] = this.data.params;
    const body = this.data.body;

    if (this.eventsGroupSubscr) {
      this.eventsGroupSubscr.unsubscribe();
    }

    if (this.group.label || this.group.label === '') {
      params = params.filter((e) => e.key !== 'groupValue');
      if (this.group.label !== 'boolean') {
        // TODO: i18n
        if (this.group.label === 'ACTIVE') {
          /* Have to make two calls as groupValue takes only one parameter */
          params.push({ key: 'groupValue', value: 'présente non acquittée' });
          this.getEventLogsByGroup(params, body, pushList);
          const groupValueIndex = params.findIndex((e) => e.key === 'groupValue');
          params.splice(groupValueIndex, 1);
          params.push({ key: 'groupValue', value: 'présente acquittée' });
        } else if (this.group.label === 'INACTIVE') {
          params.push({ key: 'groupValue', value: 'absente non acquittée' });
          this.getEventLogsByGroup(params, body, pushList);
          const groupValueIndex = params.findIndex((e) => e.key === 'groupValue');
          params.splice(groupValueIndex, 1);
          params.push({ key: 'groupValue', value: 'absente acquittée' });
        } else {
          params.push({ key: 'groupValue', value: this.group.label });
        }
        this.getEventLogsByGroup(params, body, pushList);
      } else if (this.group.label === 'boolean') {
        /* Have to make two calls (for true & false) for groupByValue booleans
          as they are grouped under "" (noname) header */
        params.push({ key: 'groupValue', value: 'false'});
        this.getEventLogsByGroup(params, body, pushList);
        const groupValueIndex = params.findIndex((e) => e.key === 'groupValue');
        params.splice(groupValueIndex, 1);
        params.push({ key: 'groupValue', value: 'true'});
        this.getEventLogsByGroup(params, body, pushList);
      }
    }
  }

  getEventLogsByGroup(params, body, pushList) {
    this.eventsGroupSubscr = this.eventsService.getEventsLogListGroupByField(
      this.data.siteId, this.offset, this.limit, params, body).subscribe({
      next: (eventsGroupPagedList: EventLogEntryList) => {
        if (pushList) {
          const newList = this.eventsList.list.concat(eventsGroupPagedList.list);
          this.eventsList.paging = eventsGroupPagedList.paging;
          this.eventsList.list = newList.slice();
          this.eventsList.list = this.eventsList.list.slice();
          const eventsListMapped = this.eventsList.list.map(event => {
            event.value = this.tableEventListMapper.getEventAlarmState(event.value);
            return event;
          });
          this.eventsList.list = eventsListMapped;
        } else {
          const eventsListMapped = eventsGroupPagedList.list.map(event => {
            event.value = this.tableEventListMapper.getEventAlarmState(event.value);
            return event;
          });
          eventsGroupPagedList.list = eventsListMapped;
          this.eventsList = eventsGroupPagedList;
        }
      },
      error: (error) => {
        const alertParams = new AlertParameters(false, false, true, false, false, false, true, 'Erreur de récupération d\'événements');
        this.alertService.showAlert(error,
              AlertType.ERROR,
              alertParams);
      }
    });
  }

  showMore() {
    this.offset = this.offset + this.limit;
    this.getEventsLogListGroupByField(true);
  }
}
